"use client";
import Image from "next/image";
import Link from "next/link";
import { Layout } from "@/components/Layout/Layout";
import { HeroBanner } from "@/components/HeroBanner/HeroBanner";
import { Timeline } from "@/components/Timeline/Timeline";
import { Heading } from "@/components/Heading/Heading";
import { Paragraph } from "@/components/Paragraph/Paragraph";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export default function Solutions() {
	return (
		<Layout>
			<HeroBanner image={"/thermal-power-solutions.png"} title="Thermal Power Solutions" about="Delivering reliable and efficient thermal power solutions that drive sustainable energy for industrial and community needs." alt="Thermal Power Solutions by Hindustan Power" />
			<section className="py-8 lg:py-16">
				<div className="hp-container flex flex-col items-center">
					<div className="text-center flex flex-col gap-4 mb-5 2xl:max-w-[60%]">
						<Heading>Powering a resilient future with reliable thermal energy.</Heading>
						<Paragraph>Hindustan Thermal Projects Limited, the thermal division of Hindustan Power, entered the sector in 2008 to support India’s power infrastructure and economic growth. Through its SPV, MB Power (Madhya Pradesh) Limited, it developed a 1250 MW (2x625) coal-based plant in Anuppur, Madhya Pradesh, with units commissioned in 2015 and 2016.</Paragraph>
						<Paragraph>Currently, about 70% of the power generated is supplied to distribution utilities in Madhya Pradesh and Uttar Pradesh through long-term agreements, with the remaining power sold via medium/short-term PPAs and power exchanges.</Paragraph>
					</div>

					<div className=" flex-wrap justify-center gap-5 lg:gap-12 py-8 w-full hidden lg:flex">
						<div className="flex flex-col gap-2 justify-center items-start py-12 px-12 rounded-[15px] bg-blue w-full lg:w-[30.33%] 2xl:w-[31%]">
							<Image alt="1250 MW thermal power capacity icon" src="/tp-1.png" width={40} height={40} unoptimized className="" />
							<h4 className="text-[50px] font-medium leading-[60px]">1250 MW</h4>
							<div className="h-[1px] bg-red w-full my-1"></div>
							<p className="text-[18px]  font-normal">MB Power (Madhaya Pradesh) Limited</p>
						</div>

						<div className="flex flex-col gap-2 justify-center items-start py-12 px-12 rounded-[15px] bg-blue w-full lg:w-[30.33%] 2xl:w-[31%]">
							<Image alt="Beneficiaries of thermal power icon" src="/tp-2.png" width={40} height={40} unoptimized className="" />
							<h4 className="text-[50px] font-medium leading-[60px]">15 Lakh</h4>
							<div className="h-[1px] bg-red w-full my-1"></div>
							<p className="text-[18px]  font-normal">Beneficiaries Being Benefited</p>
						</div>

						<div className="flex flex-col gap-2 justify-center items-start py-12 px-12 rounded-[15px] bg-blue w-full lg:w-[30.33%] 2xl:w-[31%]">
							<Image alt="Ash disposal icon" src="/tp-3.png" width={40} height={40} unoptimized className="" />
							<h4 className="text-[50px] font-medium leading-[60px]">100%</h4>
							<div className="h-[1px] bg-red w-full my-1"></div>
							<p className="text-[18px]  font-normal">Successful Ash Disposal</p>
						</div>
					</div>

					<div className="w-full beneficiary-slider block lg:hidden mt-5">
						<Swiper loop={true} pagination={{ clickable: true }} modules={[Pagination]} spaceBetween={15} slidesPerView={1.15}>
							<SwiperSlide>
								<div className="flex flex-col gap-2 justify-center items-start p-8 lg:p-12 rounded-[15px] bg-blue w-full lg:w-[30.33%] 2xl:w-[31%]">
									<Image alt="1250 MW thermal power capacity icon" src="/tp-1.png" width={40} height={40} unoptimized className="" />
									<h4 className="text-[28px] font-medium leading-[38px]">1250 MW</h4>
									<div className="h-[1px] bg-red w-full my-1"></div>
									<p className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal">MB Power (Madhaya Pradesh) Limited</p>
								</div>
							</SwiperSlide>

							<SwiperSlide>
								<div className="flex flex-col gap-2 justify-center items-start p-8 lg:p-12 rounded-[15px] bg-blue w-full lg:w-[30.33%] 2xl:w-[31%]">
									<Image alt="Beneficiaries of thermal power icon" src="/tp-2.png" width={40} height={40} unoptimized className="" />
									<h4 className="text-[28px] font-medium leading-[38px]">15 Lakh</h4>
									<div className="h-[1px] bg-red w-full my-1"></div>
									<p className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal">Beneficiaries Being Benefited</p>
								</div>
							</SwiperSlide>

							<SwiperSlide>
								<div className="flex flex-col gap-2 justify-center items-start p-8 lg:p-12 rounded-[15px] bg-blue w-full lg:w-[30.33%] 2xl:w-[31%]">
									<Image alt="Ash disposal icon" src="/tp-3.png" width={40} height={40} unoptimized className="" />
									<h4 className="text-[28px] font-medium leading-[38px]">100%</h4>
									<div className="h-[1px] bg-red w-full my-1"></div>
									<p className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal">Successful Ash Disposal</p>
								</div>
							</SwiperSlide>
						</Swiper>
					</div>
				</div>
			</section>
		</Layout>
	);
}
